import { createFileRoute } from "@tanstack/react-router";
import { EMPTY_ORG_ID } from "@/constants/org";
import { AssetTypeActivitySection } from "@/utils/asset-type-detail/asset-type-activity-section";
import { useAssetTypeDrawerContext } from "@/utils/asset-type-detail/asset-type-drawer-context";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/activity",
)({
	component: AdminAssetTypeActivityTab,
});

function AdminAssetTypeActivityTab() {
	const { assetType } = useAssetTypeDrawerContext();

	return (
		<div className="p-4">
			<AssetTypeActivitySection
				assetType={assetType}
				variant="drawer"
				organizationId={EMPTY_ORG_ID}
			/>
		</div>
	);
}
